import React, { useState } from 'react';
import '../styles/CDLManualViewer.css';

export default function CDLManualViewer({ onHome, onStartPractice, onStartExam, onGoHistory }) {
  const [sidebarOpen, setSidebarOpen] = useState(false);


  return (
    <div className="pdf-container">
      {/* Sidebar */}
      <div className={`pdf-sidebar ${sidebarOpen ? "open" : "closed"}`}>
        <div className="pdf-sidebar-header">
          <h2>📖 Guide</h2>
          <div className="pdf-sidebar-buttons">
            <button className="pdf-home-btn" onClick={onHome}>
              🏠
            </button>
            <button
              className="pdf-close-sidebar"
              onClick={() => setSidebarOpen(false)}
            >
              ✕
            </button>
          </div>
        </div>

        {/* Info */}
        <div className="pdf-sidebar-info">
          <div className="pdf-info-section">
            <h3>📘 CDL Study Guide</h3>
            <p>Complete 192-page reference manual</p>
            <p className="pdf-info-details">
              ✓ All pages<br/>
              ✓ All images<br/>
              ✓ All tables<br/>
              ✓ All text preserved
            </p>
          </div>

          <div className="pdf-info-section">
            <h3>🎯 Coverage</h3>
            <ul>
              <li>General Knowledge</li>
              <li>Air Brakes</li>
              <li>Passenger Endorsement</li>
              <li>Combination Vehicles</li>
              <li>Hazmat Materials</li>
              <li>Tanker Vehicles</li>
              <li>School Bus</li>
              <li>Skills Test</li>
            </ul>
          </div>

          <div className="pdf-info-section">
            <h3>💡 Tips</h3>
            <ul>
              <li>Use browser search (Ctrl+F)</li>
              <li>Zoom in/out with toolbar</li>
              <li>Download icon to save</li>
              <li>Full-screen for focused study</li>
            </ul>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="pdf-main">
        <button
          className="pdf-toggle-sidebar"
          onClick={() => setSidebarOpen(!sidebarOpen)}
          title="Toggle sidebar"
        >
          ☰
        </button>

        {/* PDF Viewer */}
        <div className="pdf-viewer-wrapper">
          <iframe
            className="pdf-iframe"
            src="/CDL-Study-Guide.pdf#toolbar=1&navpanes=0&scrollbar=1"
            title="CDL Study Guide - 192 Pages"
            allow="fullscreen"
          />
        </div>

        {/* Footer Menu */}
        <div className="pdf-footer">
          <div className="pdf-footer-menu">
            <button
              className="pdf-menu-btn"
              onClick={() => {
                sessionStorage.setItem('splitMode', 'practice');
                window.open(window.location.href, '_blank');
              }}
              title="Open Practice with Guide in new window"
            >
              📚 Practice
            </button>
            <button
              className="pdf-menu-btn"
              onClick={() => {
                sessionStorage.setItem('splitMode', 'exam');
                window.open(window.location.href, '_blank');
              }}
              title="Open Exam with Guide in new window"
            >
              🎯 Exam
            </button>
            <button
              className="pdf-menu-btn"
              onClick={() => {
                sessionStorage.setItem('splitMode', 'history');
                window.open(window.location.href, '_blank');
              }}
              title="Open History with Guide in new window"
            >
              📜 History
            </button>
          </div>
          <p className="pdf-footer-text">
            ✓ CDL Driver's Manual — All 192 Pages Complete | Massachusetts Registry of Motor Vehicles
          </p>
        </div>
      </div>
    </div>
  );
}
